module.exports = __webpack_public_path__ + "static/media/feliz-aniversario-bolo.97e33ab3.png";